var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "15 29 82 84",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M69.7,36.9c3.3,0,6.5,0.3,9.7,1c-6.6-4.7-14.7-7.5-23.4-7.5c-22.2,0-40.4,18.1-40.4,40.5c0,8.5,2.6,16.3,7.1,22.8c-0.5-2.8-0.8-5.8-0.8-8.8C21.8,58.4,43.3,36.9,69.7,36.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#49B69C",
    d: "M82.3,40.3c-6.3,0.4-12.4,1.7-18,4C75.7,47.8,84,58.6,83.8,71.3C83.6,86.7,71,99,55.6,98.8C43,98.7,32.5,90.1,29.2,78.7c-2.3,5.7-3.8,11.7-4.3,17.9c7.3,8.8,18.3,14.5,30.6,14.7c22.2,0.3,40.6-17.6,40.9-40C96.4,58.9,91,47.8,82.3,40.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/Logo_White.2905959c2a83f19c8c47361734657cb8.svg";
export { ForwardRef as ReactComponent };